module.exports = __webpack_public_path__ + "static/media/17.6f2b302a.jpg";